module.exports = __webpack_public_path__ + "img/fitted-mask-string-ties-default.090e18c0.jpg";